import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
import { Common } from '@/sunway/common/js/common';
import Gikam from 'gikam';
export default {
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          headerVisible: true,
          subtitle: '',
          header: [],
          items: []
        };
      }
    }
  },
  data: function data() {
    return {
      rootClass: Common.getPrefixClass('window'),
      window: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$nextTick();

            case 2:
              _this.options.renderTo = _this.$el;
              _this.window = Gikam.create('window', _this.options);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.options.renderTo = null;
    this.window.destroy();
    this.window = null;
  }
};